import React, { useEffect, useMemo, useState } from 'react';
import { api } from '../../services/api';

export default function HREmployeesPage() {
  const [q, setQ] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [list, setList] = useState([]);
  const [selected, setSelected] = useState(null);
  const [message, setMessage] = useState('');

  const statusOptions = useMemo(() => ['Activo', 'Inactivo', 'Suspendido'], []);
  const contractOptions = useMemo(() => ['Indefinido', 'Fijo', 'Temporal', 'Prácticas'], []);

  const fetchList = async () => {
    setLoading(true); setError(''); setMessage('');
    try {
      const res = await api.hr.employees.list({ q: q.trim(), limit: 25 });
      setList(res?.data || []);
    } catch (e) {
      setError(e.message || 'Error al listar empleados');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // carga inicial
    fetchList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSelect = async (row) => {
    setSelected(row);
    setMessage(''); setError('');
  };

  const onSave = async () => {
    if (!selected) return;
    setLoading(true); setError(''); setMessage('');
    try {
      const payload = {
        person_id: selected.person_id || undefined,
        dni: (selected.dni || '').trim() || undefined,
        name: (selected.name || '').trim() || undefined,
        department: selected.department || null,
        position: selected.position || null,
        hire_date: selected.hire_date || null,
        contract_type: selected.contract_type || null,
        status: selected.status || 'Activo',
      };
      await api.hr.employees.upsert(payload);
      setMessage('Empleado actualizado correctamente');
      // refrescar detalle
      const fresh = await api.hr.employees.get({ person_id: selected.person_id, dni: selected.dni });
      setSelected(fresh?.data || selected);
      // refrescar listado
      fetchList();
    } catch (e) {
      setError(e.message || 'Error al guardar');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '1rem' }}>
      <h2>RRHH · Empleados</h2>

      <div style={{ marginBottom: '1rem', display: 'flex', gap: '0.5rem' }}>
        <input
          type="text"
          placeholder="Buscar por nombre, departamento o puesto"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          style={{ flex: 1 }}
        />
        <button onClick={fetchList} disabled={loading}>Buscar</button>
      </div>

      {error && <div style={{ color: 'red' }}>{error}</div>}
      {message && <div style={{ color: 'green' }}>{message}</div>}

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
        <div>
          <h3>Listado</h3>
          <div style={{ border: '1px solid #ddd' }}>
            <table width="100%">
              <thead>
                <tr>
                  <th style={{ textAlign: 'left' }}>Nombre</th>
                  <th style={{ textAlign: 'left' }}>DNI</th>
                  <th style={{ textAlign: 'left' }}>Departamento</th>
                  <th style={{ textAlign: 'left' }}>Puesto</th>
                </tr>
              </thead>
              <tbody>
                {list.map((row) => (
                  <tr key={row.person_id}
                      style={{ cursor: 'pointer' }}
                      onClick={() => onSelect(row)}>
                    <td>{row.name || '—'}</td>
                    <td>{row.dni || '—'}</td>
                    <td>{row.department || '—'}</td>
                    <td>{row.position || '—'}</td>
                  </tr>
                ))}
                {list.length === 0 && (
                  <tr><td colSpan={4} style={{ textAlign: 'center' }}>Sin resultados</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        <div>
          <h3>Detalle</h3>
          {!selected ? (
            <div>Selecciona un empleado del listado.</div>
          ) : (
            <div style={{ display: 'grid', gap: '0.5rem' }}>
              <label>
                DNI
                <input type="text" value={selected.dni || ''}
                  onChange={(e) => setSelected({ ...selected, dni: e.target.value })} />
              </label>
              <label>
                Nombre
                <input type="text" value={selected.name || ''}
                  onChange={(e) => setSelected({ ...selected, name: e.target.value })} />
              </label>
              <label>
                Departamento
                <input type="text" value={selected.department || ''}
                  onChange={(e) => setSelected({ ...selected, department: e.target.value })} />
              </label>
              <label>
                Puesto
                <input type="text" value={selected.position || ''}
                  onChange={(e) => setSelected({ ...selected, position: e.target.value })} />
              </label>
              <label>
                Fecha de ingreso
                <input type="date" value={selected.hire_date || ''}
                  onChange={(e) => setSelected({ ...selected, hire_date: e.target.value })} />
              </label>
              <label>
                Tipo de contrato
                <select value={selected.contract_type || ''}
                  onChange={(e) => setSelected({ ...selected, contract_type: e.target.value })}>
                  <option value="">—</option>
                  {contractOptions.map((opt) => (
                    <option key={opt} value={opt}>{opt}</option>
                  ))}
                </select>
              </label>
              <label>
                Estado
                <select value={selected.status || 'Activo'}
                  onChange={(e) => setSelected({ ...selected, status: e.target.value })}>
                  {statusOptions.map((opt) => (
                    <option key={opt} value={opt}>{opt}</option>
                  ))}
                </select>
              </label>

              <div>
                <button onClick={onSave} disabled={loading}>Guardar</button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
